import Swiper from 'swiper/bundle';
// more than 3 parts
const swiper = new Swiper(".swiper", {
  // ページネーションが必要なら追加

  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },

  effect: "coverflow",
  centeredSlides: true,
  slidesPerView: 1,
  grabCursor: true,

  autoplay: {
    disableOnInteraction: false,
    reverseDirection: false,
    pauseOnMouseEnter: true,
    stopOnLast: false,
    delay: 2500
  },

  loop: true,
  coverflowEffect: {
    rotate: 0,
    stretch: -120,
    depth: 800,
    modifier: 1,
    slideShadows: false
  }

});

// less than 3 parts
// const swiper = new Swiper(".swiper", {
//   // ページネーションが必要なら追加
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true
//   },
//   // loop: true,
//   effect: 'coverflow',
//   slidesPerView: 1,
//   centeredSlides: true,
//   grabCursor: true,

//   autoplay: {
//     delay: 2500, 
//     disableOnInteraction: false
//   },

//   coverflowEffect: {
//     rotate: 0,
//     stretch: -140,
//     depth: 1000,
//     modifier: 1,
//     slideShadows: false
//   }
// });


const swiperSlide2 = new Swiper(".swiper2", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "1",
  spaceBetween: 25,

  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },

});

const swiperSlidex = new Swiper(".swiperx", {
  pagination: {
    el: ".swiper-pagination"
  },
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "1",
  spaceBetween: -20,
  autoHeight: true,

  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },

  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 0,
    modifier: 1,
    stretch: 0,
    slideShadows: false,
  },

  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});


const swiperFade = new Swiper(".swiper.m-fade", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  // ページネーションが必要なら追加
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

